import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {merge} from 'ramda';

import styles from './index.module.css';
import commonStyles from '../../../styles/common.module.css';
import ArrowButton, {DIRECTIONS} from '../arrow-button/index';

import utils from '@utils';

const DEFAULT_CONFIG = {
  header: '',
  defaultDirection: true,
  items: []
};

class Item extends Component {
  constructor(props) {
    super(props);

    this.onSelect = this.onSelect.bind(this);
  }
  onSelect() {
    if (this.props.inactive) return false;
    this.props.onSelect(this.props.index);
  }
  render() {
    return (<button className={`${this.props.className} ${this.props.inactive ? styles.bold : ''}`} onClick={this.onSelect}>{this.props.title}</button>);
  }
}

class DropDown extends Component {
  constructor(props) {
    super(props);

    this.config = merge(DEFAULT_CONFIG, props.config);
    this.state = {expanded: false};
    this.outerRef = React.createRef();

    this.onExpand = this.onExpand.bind(this);
    this.onMousedown = this.onMousedown.bind(this);

    this.onSelect = this.onSelect.bind(this);
  }

  onExpand() {
    this.setState({expanded: !this.state.expanded}, () => {
      if (this.state.expanded) {
        this.attachHandlers();
      } else {
        this.removeHandlers();
      }
    });
  }

  onSelect(index) {
    this.onExpand();
    if (this.props.onChange) {
      this.props.onChange(index);
    }
  }

  onMousedown(event) {
    if (!this.outerRef.current.contains(event.target)) {
      this.onExpand();
    }
  }

  attachHandlers() {
    document.addEventListener(utils.events.mousedown, this.onMousedown);
  }
  removeHandlers() {
    document.removeEventListener(utils.events.mousedown, this.onMousedown);
  }

  render() {
    return (<section className={`${styles.container} ${this.state.expanded ? styles.expanded : ''} ${this.props.className || ''}`} ref={this.outerRef}>
      <div className={`${styles.display} ${commonStyles.font}`} onClick={this.onExpand}>{this.config.items[this.props.value].title || this.config.placeholder || ''}</div>
      <ul className={`${styles.select} ${!this.config.defaultDirection ? styles.upward : ''}`}>
        {this.config.items.map((item, index) => <li className={`${styles.item} ${this.props.value === index ? styles.selected : ''}`} key={index}>
          <Item className={commonStyles.font} onSelect={this.onSelect} index={index} title={item.title} inactive={!!item.inactive} />
        </li>)}
      </ul>
      <ArrowButton className={styles.arrow} onClick={this.onExpand} direction={this.state.expanded ? DIRECTIONS.UP : DIRECTIONS.DOWN} light={this.props.light}/>
    </section>);
  }
}

DropDown.defaultProps = {
  light: false
};

DropDown.propTypes = {
  config: PropTypes.object.isRequired,
  light: PropTypes.bool
};

export default DropDown;